// extracted by mini-css-extract-plugin
export default {"root":"PlasmicCreateNew_root__UxlhS","text":"PlasmicCreateNew_text__VsfW7"};